import { FileText, MapPin } from "lucide-react";
import { IDENTITY, IMAGES, SKILLS } from "@/data/content";
import { SmartImg, Tag } from "@/components/primitives";

export default function AboutWindow() {
    return (
        <div data-testid="about-window" className="p-6 sm:p-8">
            <div className="flex items-center justify-between border-b border-black/10 pb-4 mb-6">
                <h2 className="text-xl font-bold tracking-tight">bio.txt — gedit</h2>
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">UTF-8 · LF · saved</span>
            </div>
            <div className="grid sm:grid-cols-[180px_1fr] gap-6 items-start">
                <div className="group">
                    <div className="rounded-md overflow-hidden border border-black/15">
                        <SmartImg
                            src={IMAGES.portrait}
                            fallback={IMAGES.portraitFallback}
                            alt="Dwiki Arlian Maulana"
                            className="w-full aspect-[4/5] object-cover halftone group-hover:scale-[1.03]"
                        />
                    </div>
                    <p className="mt-2 font-mono text-[10px] text-neutral-500 text-center">~/pictures/dwiki.jpg</p>
                </div>
                <div className="space-y-4">
                    <p className="text-lg font-semibold leading-snug">
                        Hey, I&rsquo;m Dwiki — based in Indonesia, fluent in blinking router lights and stubborn Linux servers.
                    </p>
                    <p className="text-sm text-neutral-600 leading-relaxed">
                        For the last 6 years I&rsquo;ve been the person teams call when nothing works. I plan, build, and babysit infrastructure so the rest of the company can pretend IT is magic. Bash scripts at sunrise, ticket triage at noon, network diagrams at midnight.
                    </p>
                    <p className="text-sm text-neutral-600 leading-relaxed">
                        Currently obsessed with automating boring things, observability stacks, and that satisfying green-dashboard feeling.
                    </p>
                    <div className="flex flex-wrap items-center gap-2 pt-1">
                        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] px-2.5 py-1 rounded-full bg-black/[0.05] border border-black/10 text-neutral-600">
                            <MapPin size={11} /> {IDENTITY.location}
                        </span>
                        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] px-2.5 py-1 rounded-full bg-vermilion/10 border border-vermilion/30 text-vermilion font-semibold">
                            ● Open to remote
                        </span>
                    </div>
                    <a
                        href={IDENTITY.resume}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="about-resume-button"
                        className="inline-flex items-center gap-2 rounded-md bg-[#1a1a1a] text-white px-5 py-2.5 text-xs font-semibold tracking-wide hover:bg-vermilion transition-colors duration-200"
                    >
                        <FileText size={13} /> View Resume ↗
                    </a>
                </div>
            </div>
            <div className="mt-8 border-t border-black/10 pt-6">
                <h3 className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-4">
                    /usr/share/skills — 06 packages installed
                </h3>
                <div className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
                    {SKILLS.map((g) => (
                        <div key={g.number} data-testid={`skill-group-${g.number}`}>
                            <div className="flex items-baseline justify-between mb-2">
                                <span className="font-semibold text-sm">{g.title}</span>
                                <span className="font-mono text-[10px] text-vermilion">v{g.number}.0</span>
                            </div>
                            <div className="flex flex-wrap gap-1">
                                {g.items.map((item) => (
                                    <Tag key={item}>{item}</Tag>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
